import Toast from './toast'
import VueScrollTo from 'vue-scrollto'
import Vue from 'vue'

window.initMap = function () {
  return autocompleteGooglePlaces()
}
if (window.google) {
  window.initMap()
}

export function autocompleteGooglePlaces () {
  const autocompleteFormField = document.querySelector('form input.autocomplete')
  // Don't apply this JS if this page doesn't have a form with an autocomplete input
  // It'd be preferable to only load the JS on form pages rather than this
  if (!autocompleteFormField) {
    return
  }

  // Scope queries to elements inside the form
  // Assumptions are made about the HTML structure this lives in, so it's not very flexible
  const formElement = document.querySelector('form')

  const canzAutocompleteWrapper = formElement.querySelector('#Form_ProfileForm_ResidentialAddress_Holder')
  const lostPetAutocompleteWrapper = formElement.querySelector('#Form_LostPetForm_ResidentialAddress_Holder')


  const isLostPetForm = lostPetAutocompleteWrapper ? true : false

  const autocompleteWrapper = isLostPetForm ? lostPetAutocompleteWrapper : canzAutocompleteWrapper

  const placeholderText = isLostPetForm ? 'Start typing street name' : 'Start typing your address'
  autocompleteFormField.setAttribute('placeholder', placeholderText)

  const addressBtnElement = formElement.querySelector('#manual-address')
  const manualAddressLink = formElement.querySelector('#manual-address-link')
  const manualAddressHelp = formElement.querySelector('#manual-address-help')
  const manualAddressPrompt = formElement.querySelector('#check-address-warning')
  const autocompleteLabel = autocompleteWrapper?.querySelector('.c-form-field__label')
  const addressFieldsWrapper = formElement.querySelector('#Form_ProfileForm_StreetNumberStreetSuburbCityRegionPostalCodeLongitudeLatitude_Holder')

  // For some reason, the address component is responsible for displaying the toast message for the
  // _whole form_ if any validation errors are displayed even outside the component
  const errorMessages = formElement.querySelectorAll('.c-message')
  const guardianFormWrapper = formElement.querySelector('#Residentialaddress')
  const addressErrorMessage = guardianFormWrapper?.querySelectorAll('.c-message')[0]
  const isMigratedUser = formElement.querySelector('#Form_ProfileForm_MigratedUser')
  const submit = formElement.querySelector('#Form_ProfileForm_action_save')
  const autocompleteFormWarning = formElement.querySelector('#address-warning')
  const latitudeField = formElement.querySelector('[name="Latitude"]')
  const longitudeField = formElement.querySelector('[name="Longitude"]')

  const placesComponent = {
    UnitNumber: ['subpremise'],
    StreetNumber: ['street_number'],
    Street: ['street_address', 'route'],
    Suburb: [
      'sublocality',
      'sublocality_level_1',
      'sublocality_level_2',
      'sublocality_level_3',
      'sublocality_level_4'
    ],
    City: [
      'locality'
    ],
    PostalCode: ['postal_code'],
    Region: [
      'administrative_area_level_1',
      'administrative_area_level_2',
      'administrative_area_level_3',
      'administrative_area_level_4',
      'administrative_area_level_5'
    ]
  }

  function createEvent (type) {
    var event
    if (typeof window.Event === 'function') {
      event = new window.Event(type)
    } else {
      event = document.createEvent('Event')
      event.initEvent(type, true, true)
    }
    return event
  }

  function toggleManualAddress () {
    if (autocompleteFormField.value.length > 0) {
      showElement(manualAddressPrompt)
      hideElement(manualAddressLink)
      hideElement(manualAddressHelp)
      if (addressFieldsWrapper) {
        showElement(addressFieldsWrapper)
        addressFieldsWrapper.querySelector('input').focus()
      }
      if (autocompleteLabel) {
        autocompleteLabel.innerHTML = 'Residential address'
      }
      autocompleteFormField.dispatchEvent(createEvent('blur'))
    } else {
      // autocomplete field is empty or just cleared
      hideElement(manualAddressPrompt)

      if (addressFieldsWrapper) {
        if (!addressFieldsWrapper.classList.contains('hide')) {
          // user has already opened manual fields
          hideElement(manualAddressLink)
          showElement(manualAddressHelp)
          if (autocompleteLabel) {
            autocompleteLabel.innerHTML = 'Residential address'
          }
        } else {
          // manual fields are currently hidden
          showElement(manualAddressLink)
          hideElement(manualAddressHelp)
          if (autocompleteLabel) {
            autocompleteLabel.innerHTML = 'Residential address <span class="c-form-field__required">*</span>'
          }
        }
      }

      autocompleteFormField.focus()
    }
  }

  function hideElement (element) {
    if (element && !element.classList.contains('hide')) {
      element.classList.add('hide')
    }
  }

  function showElement (element) {
    if (element && element.classList.contains('hide')) {
      element.classList.remove('hide')
    }
  }

  if (autocompleteFormField) {
    autocompleteFormField.addEventListener('search', function (e) {
      if (autocompleteFormField.value.length === 0) {
        clearManualAddressFields()
        toggleManualAddress()
        if (isLostPetForm) {
          autocompleteFormField.value = ''
          autocompleteFormField.dispatchEvent(createEvent('change'))
        }
      }
    })
    autocompleteFormField.addEventListener('keydown', function (e) {
      // prevent 'enter' from submitting the form if a user
      // uses enter to select the address in the dropdown
      if (e.keyCode === 13) {
        e.preventDefault()
      }
    })
    autocompleteFormField.addEventListener('focusout', function (e) {
      // clear manual fields if autocomplete field is manually cleared
      if (autocompleteFormField.value.length === 0) {
        clearManualAddressFields()
      }
    })
    // make sure on the Member profile form the required fields are all visible.
    if (submit) {
      submit.addEventListener('click', function (e) {
        showElement(addressFieldsWrapper)
      })
    }

    autocompleteFormField.value = ''
    const addressObj = {}
    let noMissingFields = true
    for (var type in placesComponent) {
      const field = formElement.querySelector('[name="' + type + '"]')
      if (field && field.value !== '' && noMissingFields) {
        // Compile the address lookup input with values existing in fields.
        addressObj[type] = field.value
      } else {
        if (autocompleteFormWarning) {
          // Detect if the member is on the profile form page based on whether the form warning exists.
          if (type !== 'Suburb' && type !== 'UnitNumber') {
            // Suburb is an optional field so if it doesn't exist we can ignore.
            autocompleteFormField.value = ''
            noMissingFields = false
            // Clear out autocomplete input to indicate to member this is required
            if (isMigratedUser) {
              // We will only display the message that your address needs to be updated if the member has been migrated.
              autocompleteFormWarning.classList.remove('hide')
            }
          }
        }
      }
    }

    if (addressBtnElement) {
      if (autocompleteLabel) {
        autocompleteLabel.innerHTML = 'Residential address <span class="c-form-field__required">*</span>'
      }

      // make sure that all fields are available if errors are returned from the server.
      if (errorMessages.length > 0) {
        showElement(addressFieldsWrapper)
        if (addressErrorMessage) {
          hideElement(addressErrorMessage)
        }
        hideElement(autocompleteFormWarning)
        hideElement(manualAddressLink)
        hideElement(manualAddressPrompt)
        showElement(manualAddressHelp)
        if (autocompleteLabel) {
          autocompleteLabel.innerHTML = 'Residential address'
        }

        Vue.$toast.error({
          component: Toast,
          props: {
            heading: 'Changes not saved',
            body: 'Please review validation errors and try again.'
          }
        })

        VueScrollTo.scrollTo(errorMessages[0], 400, {
          offset: -75
        })
      }

      // ensure either the search field is shown or the manual fields.
      addressBtnElement.addEventListener('click', function (e) {
        e.preventDefault()
        showElement(addressFieldsWrapper)
        hideElement(manualAddressLink)
        showElement(manualAddressHelp)
        addressFieldsWrapper.querySelector('input').focus()
        if (autocompleteLabel) {
          autocompleteLabel.innerHTML = 'Residential address'
        }
      })
    }

    const removeNullsAndJoin = (strings, separator) => {
      return strings
        .filter((str) => !!str)
        .join(separator)
    }

    const getFormattedAddressParts = (addressObj) => {
      const StreetNumber = removeNullsAndJoin([addressObj.UnitNumber, addressObj.StreetNumber], '/')
      return {
        StreetNumber,
        Street: addressObj.Street,
        StreetNumberAndName: removeNullsAndJoin([StreetNumber, addressObj.Street], ' '),
        Suburb: addressObj.Suburb,
        City: addressObj.City,
        CityAndPostCode: removeNullsAndJoin([addressObj.City, addressObj.PostalCode], ' '),
        Region: addressObj.Region,
      }
    }

    // Formats the address parts into a string like '1/12 North St, Suburb, City 2022, Region'
    const getFullAddressString = addressObj => {
      const { Street, StreetNumberAndName, Suburb, City, CityAndPostCode, Region } = getFormattedAddressParts(
        addressObj,
      )
      if (isLostPetForm) {
        return removeNullsAndJoin([Street, Suburb, City], ', ')
      }
      return removeNullsAndJoin([StreetNumberAndName, Suburb, CityAndPostCode, Region], ', ')
    }

    // Sets the individual address field values (Street number, Street name, Suburb, etc)
    const populateFields = (addressObj) => {
      const formattedParts = getFormattedAddressParts(addressObj)
      for (const fieldName in addressObj) {
        const field = formElement.querySelector('[name="' + fieldName + '"]')
        // insert values into vanilla JS
        if (field) {
          if (isLostPetForm && fieldName == 'Region') {
            const options = Array.from(field.options)
            options.forEach(element => {
              if (element.text == addressObj[fieldName]) {
                element.selected = true
                field.dispatchEvent(createEvent('change'))
              }
            })
          } else {
            field.value = formattedParts[fieldName] || addressObj[fieldName] || ''
            field.dispatchEvent(createEvent('input'))
          }
        }
      }
    }

    const clearManualAddressFields = () => {
      // reset address model
      const address = {
        UnitNumber: '',
        StreetNumber: '',
        Street: '',
        Suburb: '',
        City: '',
        Region: '',
        PostalCode: ''
      }
      // reset fields
      populateFields(address)
      if (latitudeField) {
        latitudeField.value = ''
        latitudeField.dispatchEvent(createEvent('input'))
      }
      if (longitudeField) {
        longitudeField.value = ''
        longitudeField.dispatchEvent(createEvent('input'))
      }
    }

    // Set the address string in the input, assuming we have all the fields we need
    if (noMissingFields) {
      autocompleteFormField.value = getFullAddressString(addressObj)
    }

    if (autocompleteFormField) {
      const autocomplete = new window.google.maps.places.Autocomplete((autocompleteFormField), {
        types: ['address'],
        fields: ['formatted_address', 'address_components', 'geometry'],
        componentRestrictions: { country: ['nz'] }
      })
      window.google.maps.event.addListener(autocomplete, 'place_changed', () => {
        // reset address model
        const address = {
          UnitNumber: '',
          StreetNumber: '',
          Street: '',
          Suburb: '',
          City: '',
          Region: '',
          PostalCode: '' 
        }
        // reset fields
        populateFields(address)

        // Custom methods to populate form fields.
        const place = autocomplete.getPlace()
        if (latitudeField && place?.geometry?.location?.lat()) {
          latitudeField.value = place.geometry.location.lat()
          latitudeField.dispatchEvent(createEvent('input'))
        }
        if (longitudeField && place?.geometry?.location?.lng()) {
          longitudeField.value = place.geometry.location.lng()
          longitudeField.dispatchEvent(createEvent('input'))
        }

        (place?.address_components || []).forEach(component => {
          for (var type in placesComponent) {
            if (placesComponent[type].indexOf(component.types[0]) !== -1) {
              address[type] = component.long_name
            }
          }
        })

        populateFields(address)

        if (isLostPetForm) {
          autocompleteFormField.value = getFullAddressString(address)
          autocompleteFormField.dispatchEvent(createEvent('change'))
        } else {
          if (autocompleteFormWarning) {
            hideElement(autocompleteFormWarning)
          }
          toggleManualAddress()
        }
      })
    }
  }
}
